<template>
  <AccordionItem :class="$style.root">
    <div ref="rootElement">
      <AccordionHeader :class="$style.header">
        <AccordionTrigger :class="$style.trigger">
          <div>
            <slot name="heading" />
          </div>

          <div :class="$style.buttonContainer">
            <div :class="$style.button" :data-active="active ? '' : null">
              <SvgoPlus :class="$style.plus" />
              <SvgoMinus :class="$style.minus" />
            </div>
          </div>
        </AccordionTrigger>
      </AccordionHeader>

      <AccordionContent :class="$style.content">
        <slot name="content" />
      </AccordionContent>
    </div>
  </AccordionItem>
</template>


<script setup>
const props = defineProps({
  entry: Object,
  active: {
    type: Boolean,
    default: false
  }
})

const rootElement = ref(null)
const isActive = computed(() => props?.active)

watch(isActive, (value) => {
  if (value) {
    if (rootElement.value instanceof HTMLElement) {
      setTimeout(() => {
        rootElement.value.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }, 325)
    }
  }
})
</script>

<style module>
.root {
}

.root:first-of-type {
  border-top: var(--stroke--default) solid var(--color--primary);
}

.root {
  border-bottom: var(--stroke--default) solid var(--color--primary);
}


.header {
  composes: reset-heading from global;

  transition: color var(--transition--default), background-color var(--transition--default);

  --button-square--border-color: var(--color--secondary);
}


.header:hover,
.header[data-state="open"] {
  --button-square--background-color: var(--color--yellow);
  --button-square--color: var(--color--black);
  --button-square--border-color: transparent;
}

.trigger {
  composes: reset-button from global;

  width: 100%;
  text-align: left;

  display: grid;
  grid-template-columns: 1fr var(--width--button--round);
  gap: var(--unit--horizontal);
  align-items: center;

  padding-top: calc(var(--unit--vertical) - (var(--stroke--default) * 2));
  padding-bottom: calc(var(--unit--vertical) - var(--stroke--default) * 1);
}

.content {
  margin-left: 0;
  overflow: hidden;
}

.content[data-state="open"] {
  animation: slideDown 300ms ease-out;
}
.content[data-state="closed"] {
  animation: slideUp 300ms ease-out;
}

.buttonContainer {
  position: relative;
}

.button {
  composes: button-square from global;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  --button-square--stroke: var(--stroke--default);
}

.trigger[data-state="open"] .plus {
  display: none;
}

.trigger[data-state="closed"] .minus {
  display: none;
}

.plus,
.minus {
}

@keyframes slideDown {
  from {
    height: 0;
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
}
</style>
